export enum MapDrawType {
    FILTER = 'select',
    MEASURE = 'measure'
}
